import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import './../../styles/admin/cupones.css';
import * as globals from '../../components/GlobalScripts.js';

import CuponesToolbar from './complements/cupones/CuponesToolbar.jsx';
import CuponesTable from './complements/cupones/CuponesTable.jsx';
import CuponFormModal from './complements/cupones/CuponFormModal.jsx';
import CuponAssignModal from './complements/cupones/CuponAssignModal.jsx';
import CuponRedencionesModal from './complements/cupones/CuponRedencionesModal.jsx';

export default function Admin_cupones() {
    const path_api = localStorage.getItem('path_api');

    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [paging, setPaging] = useState({ page: 1, total_pages: 1, total: 0, itemsPerPage: 12 });

    const [filters, setFilters] = useState({
        q: '',
        activo: 'all',
        tipo_descuento: 'all',
    });

    const [modalFormOpen, setModalFormOpen] = useState(false);
    const [editingCoupon, setEditingCoupon] = useState(null);

    const [modalAssignOpen, setModalAssignOpen] = useState(false);
    const [assignCoupon, setAssignCoupon] = useState(null);

    const [modalRedOpen, setModalRedOpen] = useState(false);
    const [redCoupon, setRedCoupon] = useState(null);

    const apiPayloadBase = useMemo(() => ({
        rute: globals.getRuteBackend(),
        session_id: globals.get_session_id(),
        keylogin: globals.get_keylogin(),
    }), []);

    const fetchList = async ({ page = 1 } = {}) => {
        setLoading(true);
        globals.openViewCharge();

        try {
            const res = await axios.post(`${path_api}/admin/cupones/list.php`, {
                ...apiPayloadBase,
                page,
                itemsPerPage: paging.itemsPerPage,
                q: filters.q,
                activo: filters.activo,
                tipo_descuento: filters.tipo_descuento,
            });

            if (res.data?.mensaje === 'success') {
                setItems(Array.isArray(res.data?.items) ? res.data.items : []);
                const p = res.data?.paging || res.data?.pagination || null;

                if (p) {
                    setPaging({
                        page: Number(p.page || page),
                        total_pages: Number(p.total_pages || 1),
                        total: Number(p.total || 0),
                        itemsPerPage: Number(p.itemsPerPage || paging.itemsPerPage),
                    });
                } else {
                    setPaging((prev) => ({ ...prev, page }));
                }
                return;
            }

            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: res.data?.mensaje || "No se pudieron cargar los cupones",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
        } catch {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar cupones",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
        } finally {
            globals.closeViewCharge();
            setLoading(false);
        }
    };

    useEffect(() => {
        globals.validateSession();
        fetchList({ page: 1 });
    }, []);

    const onApplyFilters = () => {
        fetchList({ page: 1 });
    };

    const onClearFilters = () => {
        setFilters({ q: '', activo: 'all', tipo_descuento: 'all' });
        setTimeout(() => fetchList({ page: 1 }), 0);
    };

    const openCreate = () => {
        setEditingCoupon(null);
        setModalFormOpen(true);
    };

    const openEdit = (coupon) => {
        setEditingCoupon(coupon || null);
        setModalFormOpen(true);
    };

    const openAssign = (coupon) => {
        setAssignCoupon(coupon || null);
        setModalAssignOpen(true);
    };

    const openRedenciones = (coupon) => {
        setRedCoupon(coupon || null);
        setModalRedOpen(true);
    };

    const handleUpsert = async (payloadCoupon) => {
        globals.openViewCharge();
        try {
            const res = await axios.post(`${path_api}/admin/cupones/upsert.php`, {
                ...apiPayloadBase,
                cupon: payloadCoupon,
            });

            if (res.data?.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Listo",
                    msg: "Cupón guardado correctamente",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 3000
                });
                setModalFormOpen(false);
                setEditingCoupon(null);
                fetchList({ page: paging.page });
                return true;
            }

            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: res.data?.mensaje || "No se pudo guardar el cupón",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
            return false;
        } catch {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al guardar cupón",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
            return false;
        } finally {
            globals.closeViewCharge();
        }
    };

    const handleToggle = async (coupon) => {
        if (!coupon?.id) return;

        const nextActivo = Number(coupon.activo) ? 0 : 1;

        setItems((prev) => prev.map((c) => (c.id === coupon.id ? { ...c, activo: nextActivo } : c)));

        try {
            const res = await axios.post(`${path_api}/admin/cupones/toggle.php`, {
                ...apiPayloadBase,
                cupon_id: coupon.id,
                activo: nextActivo,
            });

            if (res.data?.mensaje === 'success') return;

            setItems((prev) => prev.map((c) => (c.id === coupon.id ? { ...c, activo: Number(coupon.activo) } : c)));

            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: res.data?.mensaje || "No se pudo cambiar el estado",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
        } catch {
            setItems((prev) => prev.map((c) => (c.id === coupon.id ? { ...c, activo: Number(coupon.activo) } : c)));
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cambiar estado",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
        }
    };

    const handleAssign = async ({ cupon_id, keylogins = [], nota = '' }) => {
        if (!cupon_id || !Array.isArray(keylogins) || keylogins.length === 0) return false;

        globals.openViewCharge();
        try {
            const res = await axios.post(`${path_api}/admin/cupones/assign.php`, {
                ...apiPayloadBase,
                cupon_id,
                keylogins,
                nota: String(nota || '').trim() || null,
            });

            if (res.data?.mensaje === 'success') {
                const inserted = Number(res.data?.inserted || 0);

                globals.createAlert({
                    type: "success",
                    msg_title: "Asignado",
                    msg: inserted > 0
                        ? `Se asignó a ${inserted} cliente(s).`
                        : "El cupón ya estaba asignado a los clientes seleccionados (se reactivó si estaba inactivo).",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4200
                });

                setModalAssignOpen(false);
                setAssignCoupon(null);
                return true;
            }

            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: res.data?.mensaje || "No se pudo asignar el cupón.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });

            return false;
        } catch {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al asignar el cupón.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
            return false;
        } finally {
            globals.closeViewCharge();
        }
    };

    const goPrev = () => {
        const prev = Math.max(1, Number(paging.page) - 1);
        if (prev !== paging.page) fetchList({ page: prev });
    };

    const goNext = () => {
        const next = Math.min(Number(paging.total_pages || 1), Number(paging.page) + 1);
        if (next !== paging.page) fetchList({ page: next });
    };

    return (
        <div className="page-cupones container-section flex-column gap-20">
            <div className="cupon-head">
                <div className="flex-column gap-5">
                    <h3>Cupones</h3>
                    <p className="cupon-subtitle">
                        Crea cupones, actívalos/desactívalos, asígnalos a clientes y revisa redenciones.
                    </p>
                </div>

                <button className="cupon-btn cupon-btn--primary" onClick={openCreate} type="button">
                    <span className="cupon-btn__icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" /></svg>
                    </span>
                    Nuevo cupón
                </button>
            </div>

            <CuponesToolbar
                value={filters}
                onChange={setFilters}
                onSearch={onApplyFilters}
                onClear={onClearFilters}
                disabled={loading}
            />

            <CuponesTable
                items={items}
                loading={loading}
                onEdit={openEdit}
                onAssign={openAssign}
                onRedenciones={openRedenciones}
                onToggle={handleToggle}
            />

            <div className="cupon-pager">
                <button className="cupon-btn cupon-btn--ghost" type="button" onClick={goPrev} disabled={Number(paging.page) <= 1 || loading}>
                    <span className="cupon-btn__icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" /></svg>
                    </span>
                    Anterior
                </button>

                <div className="cupon-pager__meta">
                    <b>Página:</b> {paging.page} / {paging.total_pages} &nbsp;·&nbsp; <b>Total:</b> {paging.total}
                </div>

                <button className="cupon-btn cupon-btn--ghost" type="button" onClick={goNext} disabled={Number(paging.page) >= Number(paging.total_pages) || loading}>
                    Siguiente
                    <span className="cupon-btn__icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" /></svg>
                    </span>
                </button>
            </div>

            <CuponFormModal
                open={modalFormOpen}
                initial={editingCoupon}
                onClose={() => { setModalFormOpen(false); setEditingCoupon(null); }}
                onSubmit={handleUpsert}
            />

            <CuponAssignModal
                open={modalAssignOpen}
                coupon={assignCoupon}
                onClose={() => { setModalAssignOpen(false); setAssignCoupon(null); }}
                onAssign={handleAssign}
            />

            <CuponRedencionesModal
                open={modalRedOpen}
                coupon={redCoupon}
                apiBase={path_api}
                apiPayloadBase={apiPayloadBase}
                onClose={() => { setModalRedOpen(false); setRedCoupon(null); }}
            />
        </div>
    );
}
